import { render, staticRenderFns } from "./component-mask-selector-quiz-form.vue?vue&type=template&id=2d47fdaa&scoped=true&"
import script from "./component-mask-selector-quiz-form.vue?vue&type=script&lang=js&"
export * from "./component-mask-selector-quiz-form.vue?vue&type=script&lang=js&"
import style0 from "./component-mask-selector-quiz-form.vue?vue&type=style&index=0&id=2d47fdaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47fdaa",
  null
  
)

export default component.exports